export default "__VITE_ASSET__556741ca__"